// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

import { LoginResponseFragmentDoc } from './fragments/loginResponse.generated';
import { LoginResponseSuccessFragmentDoc } from './fragments/loginResponseSuccess.generated';
import { MeFragmentDoc } from '../fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../fragments/costumerConsultant.fragment.generated';
import { LoginResponseFailureFragmentDoc } from './fragments/loginResponseFailure.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const LoginDocument = `
    mutation login($credentials: CredentialsInput!, $locale: Locale!, $isConsultant: Boolean!) {
  login(credentials: $credentials) {
    ...loginResponse
  }
}
    ${LoginResponseFragmentDoc}
${LoginResponseSuccessFragmentDoc}
${MeFragmentDoc}
${CostumerConsultantFragmentDoc}
${LoginResponseFailureFragmentDoc}`;

export function useLoginMutation() {
  return Urql.useMutation<SchemaTypes.LoginMutation, SchemaTypes.LoginMutationVariables>(LoginDocument);
};